import primary from './primary'
import secondary from './secondary'
import paper from './paper'
import paperLg from './paper-lg'
import paperMd from './paper-md'
import interactive from './interactive'

export default {
  primary,
  paper,
  secondary,
  'paper-lg': paperLg,
  'paper-md': paperMd,
  interactive
}
